export default function Clientes() {
    return(<h1>Lista clientes</h1>)
}